import emojiRegex from "emoji-regex";

const removeEmojis = (inputString) => {
    //emojiRegex 라이브러리 사용하여 체크
    const regex = emojiRegex();
    return inputString.replace(regex, '');
}

export default removeEmojis;
